<template>
  <div class="">
    <div class="content flex-start-start">
      <span class="red-text">*</span>
      <span class="text">提示：数字藏品为虚拟数字商品，一经购买或转赠成功，将不支持撤回或退换，数字藏品相关权益将同步转移给购买或转赠成功的账户所有者或最终受益人。女娲NVWA坚决反对数字藏品炒作、场外交易、欺诈等行为。请您基于个人消费能力和需要理性购买。</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['remindDialogVisible', 'info'],
  data () {
    return {
      remindVisible: false
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.content{
  width: 1120px;
  height: 126px;
  background: #fff;
  border-radius: 2px;
  padding: 35px 57px;
  margin:21px 0;
  @media screen and(max-width:768px) {
    width: 100%;
    height: 142px;
    padding: 24px 24px 17px 15px;
  }
  .red-text{
    font-size: 14px;
    font-weight: 500;
    color: #D94949;
    line-height: 28px;
    margin-right:8px;
    @media screen and(max-width:768px){
      font-size: 12px;
      line-height: 20px;
    }
  }
  .text{
    width: 990px;
    height: 56px;
    font-size: 14px;
    font-weight: 400;
    color: #4E4E4E;
    line-height: 28px;
    @media screen and(max-width:768px){
      font-size: 12px;
      line-height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/conponents/infoRemind/index.vue